import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

function Services() {
  return (
    <div className="services">
      <section className="page-header">
        <div className="header-particles">
          <div className="particle particle-1">🚀</div>
          <div className="particle particle-2">💻</div>
          <div className="particle particle-3">⚙️</div>
          <div className="particle particle-4">📊</div>
          <div className="particle particle-5">🔒</div>
        </div>
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive AI and cloud solutions tailored for SMEs</p>
        </div>
      </section>

      <section className="services-content">
        <div className="container">
          <div className="services-intro">
            <h2>Transformative Solutions for Modern Businesses</h2>
            <p>
              We offer a complete suite of AI-driven automation and cloud consulting services 
              designed to help your business operate more efficiently, reduce costs, and scale 
              with confidence.
            </p>
          </div>

          <div className="services-detailed">
            {/* Service 1 */}
            <div className="service-detail-card">
              <div className="service-detail-header">
                <div className="service-number">01</div>
                <h3>AI Workflow Automation</h3>
              </div>
              <p className="service-description">
                Streamline your business operations with intelligent automation. We build custom 
                AI assistants and integrate cutting-edge language models to handle repetitive tasks, 
                freeing your team to focus on strategic work.
              </p>
              <div className="service-features">
                <h4>What We Deliver:</h4>
                <ul>
                  <li>Automated HR processes (onboarding, leave management, performance tracking)</li>
                  <li>Financial workflow automation (invoice processing, expense reporting)</li>
                  <li>Customer support automation with AI chatbots</li>
                  <li>Custom ChatGPT API integrations for internal tools</li>
                  <li>Automated reporting dashboards and analytics</li>
                  <li>Document processing and data extraction</li>
                </ul>
              </div>
              <Link to="/services/ai-workflow-automation" className="btn btn-outline">
                View Details →
              </Link>
            </div>

            {/* Service 2 */}
            <div className="service-detail-card">
              <div className="service-detail-header">
                <div className="service-number">02</div>
                <h3>Cloud & DevOps Setup for Startups</h3>
              </div>
              <p className="service-description">
                Build a robust, scalable cloud infrastructure from day one. We design and implement 
                production-ready environments on AWS or Azure, complete with automated deployment 
                pipelines and cost optimization strategies.
              </p>
              <div className="service-features">
                <h4>What We Deliver:</h4>
                <ul>
                  <li>AWS/Azure infrastructure setup and configuration</li>
                  <li>CI/CD pipeline implementation (GitHub Actions, GitLab, Jenkins)</li>
                  <li>Infrastructure as Code (Terraform, CloudFormation)</li>
                  <li>Cloud cost optimization and monitoring</li>
                  <li>Security best practices and compliance setup</li>
                  <li>Scalable architecture design and implementation</li>
                </ul>
              </div>
              <Link to="/services/cloud-devops" className="btn btn-outline">
                View Details →
              </Link>
            </div>

            {/* Service 3 */}
            <div className="service-detail-card">
              <div className="service-detail-header">
                <div className="service-number">03</div>
                <h3>AI Strategy Consulting</h3>
              </div>
              <p className="service-description">
                Navigate your AI transformation journey with expert guidance. We assess your current 
                state, identify opportunities, and create a roadmap that delivers measurable business value.
              </p>
              <div className="service-features">
                <h4>What We Deliver:</h4>
                <ul>
                  <li>Comprehensive AI readiness assessment</li>
                  <li>Custom automation roadmap aligned with business goals</li>
                  <li>ROI estimation and business case development</li>
                  <li>Technology stack recommendations</li>
                  <li>Implementation planning and phased rollout strategy</li>
                  <li>Change management and team training guidance</li>
                </ul>
              </div>
              <Link to="/services/ai-strategy" className="btn btn-outline">
                View Details →
              </Link>
            </div>
          </div>

          <div className="process-section">
            <h2>Our Approach</h2>
            <div className="process-steps">
              <div className="process-step">
                <div className="step-number">1</div>
                <h4>Discovery</h4>
                <p>Understand your business needs and challenges</p>
              </div>
              <div className="process-step">
                <div className="step-number">2</div>
                <h4>Strategy</h4>
                <p>Design tailored solutions with clear ROI</p>
              </div>
              <div className="process-step">
                <div className="step-number">3</div>
                <h4>Implementation</h4>
                <p>Build and deploy with agile methodology</p>
              </div>
              <div className="process-step">
                <div className="step-number">4</div>
                <h4>Optimization</h4>
                <p>Monitor, refine, and scale your solutions</p>
              </div>
            </div>
          </div>

          <div className="cta-box">
            <h2>Ready to Get Started?</h2>
            <p>Let's discuss which services are right for your business</p>
            <Link to="/contact" className="btn btn-primary">Schedule a Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
